import { useContext, useEffect, useState } from "react";
import { AppContext } from "../Context";

function ParamCuff() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [cuff, setCuff] = useState("1ButtonSquare");
    const buttons = [{ id: "standard", caption: "Standard", active: true }, { id: "french", caption: "French", active: false }];
    const items = [
        { id: "1ButtonSquare", caption: "1 Button Squared", img: "1buttonsquare.svg", active: true },
        { id: "1ButtonCurve", caption: "1 Button Curved", img: "1buttoncurve.svg", active: false },
        { id: "1ButtonAngle", caption: "1 Button Angled", img: "1buttonangle.svg", active: false },
        { id: "2ButtonSquare", caption: "2 Button Squared", img: "2buttonsquare.svg", active: true },
        { id: "2ButtonCurve", caption: "2 Button Curved", img: "2buttoncurve.svg", active: false },
        { id: "2ButtonAngle", caption: "2 Button Angled", img: "2buttonangle.svg", active: false },
        { id: "frenchSquare", caption: "French Squared", img: "frenchsquare.svg", active: false },
        { id: "frenchCurve", caption: "French Curved", img: "frenchcurve.svg", active: false },
        { id: "frenchAngle", caption: "French Angled", img: "frenchangle.svg", active: false },

    ]
    const [cuffCategory, setCuffCategory] = useState("standard");

    function onTypeClick(id) {
        setCuffCategory(id);
    }

    function onItemClick(id) {
        dispatch({ type: "SET_CUFF", payload: id });
        setCuff(id);
        if (id == "1ButtonSquare" || id == "1ButtonCurve" || id == "1ButtonAngle" || id == "2ButtonSquare" || id == "2ButtonCurve" || id == "2ButtonAngle") {
            dispatch({ type: "SET_CUFF_CATEGORY", payload: "standard" });
            dispatch({ type: "SET_CUFF_PRICE", payload: 0 });
            if (id == "1ButtonSquare" || id == "1ButtonCurve" || id == "1ButtonAngle") {
                dispatch({ type: "SET_CUFF_BUTTON", payload: 1 });
            } else {
                dispatch({ type: "SET_CUFF_BUTTON", payload: 2 });
            }
        } else {
            dispatch({ type: "SET_CUFF_CATEGORY", payload: "french" });
            dispatch({ type: "SET_CUFF_BUTTON", payload: 1 });
            dispatch({ type: "SET_CUFF_PRICE", payload: 10 });
        }
        dispatch({ type: "SET_DONE", payload: true });
    }
    useEffect(() => {
        setCuff(state.cuff);
        if (state.cuffCategory == "standard") {
            setCuffCategory("standard");
            dispatch({ type: "SET_CUFF_PRICE", payload: 0 });
        } else {
            setCuffCategory("french");
            dispatch({ type: "SET_CUFF_PRICE", payload: 10 });
        }
    }, [state.cuff, state.cuffCategory])
    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Cuff</div>
                <div className="btnBox">
                    {buttons.map((btn, index) => (
                        <div
                            onClick={() => onTypeClick(btn.id)}
                            className={`paramButtons ${cuffCategory === btn.id ? "active" : ""}`}
                            key={index}
                        >
                            {btn.caption}
                        </div>
                    ))}
                </div>
                <div className="paramPrice" style={{ display: cuffCategory === "french" ? "block" : "none" }}>
                    +$10
                </div>
            </div>

            <div className="monoList">
                {items.map((item, index) => {
                    const isVisible =
                        (cuffCategory === "standard" && index < 6) ||
                        (cuffCategory === "french" && index >= 6 && index < 9);
                    return (
                        <div
                            key={item.id}
                            onClick={() => onItemClick(item.id)}
                            className="subMenuType"
                            style={{ display: isVisible ? "flex" : "none" }}
                        >
                            <img
                                className="fabricImg"
                                src={`${process.env.PUBLIC_URL}/images/${item.img}`}
                            />
                            <div className="subMenuLabel">{item.caption}</div>
                            {state.cuff === item.id && (
                                <img className="tick" src={process.env.PUBLIC_URL + "/images/tick.svg"} width={20} alt="selected" />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    )
}
export default ParamCuff